import { recordApiError, recordApiMetric } from "./telemetry";

const CRITICAL_ENDPOINT_PATTERNS = [
  /^\/auth\/(register|login|mfa\/verify-login)$/,
  /^\/friends\/accept\/[^/]+$/,
  /^\/messages\/send$/,
  /^\/reviews$/,
  /^\/games\/\d+$/,
];

function nowMs() {
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    return performance.now();
  }
  return Date.now();
}

function normalizePath(rawUrl) {
  if (!rawUrl) return "";
  let path = String(rawUrl).trim();

  try {
    if (path.startsWith("http://") || path.startsWith("https://")) {
      path = new URL(path).pathname;
    }
  } catch {
    // noop
  }

  const qIndex = path.indexOf("?");
  if (qIndex >= 0) path = path.slice(0, qIndex);

  if (!path.startsWith("/")) path = `/${path}`;
  if (path.startsWith("/api/")) path = path.slice(4);
  if (path === "/api") path = "/";

  return path;
}

function inferCategory(path) {
  if (path.startsWith("/auth/")) return "auth";
  if (path.startsWith("/messages/")) return "messages";
  if (path.startsWith("/friends/")) return "friends";
  if (path.startsWith("/reviews")) return "reviews";
  if (path.startsWith("/games/")) return "games";
  return "general";
}

function isCriticalPath(path) {
  return CRITICAL_ENDPOINT_PATTERNS.some((pattern) => pattern.test(path));
}

function extractMeta(config = {}) {
  const startedAt = Number(config?.metadata?.startedAt);
  return {
    method: String(config?.method || "GET").toUpperCase(),
    path: normalizePath(config?.url),
    startedAt: Number.isFinite(startedAt) ? startedAt : null,
  };
}

function computeDuration(startedAt) {
  if (!Number.isFinite(startedAt)) return null;
  return Math.max(0, nowMs() - startedAt);
}

export function createRequestTelemetryMeta() {
  return {
    startedAt: nowMs(),
  };
}

export function trackApiTelemetryFromAxiosResponse(response) {
  if (!response || !response.config) return;

  const { method, path, startedAt } = extractMeta(response.config);
  if (!isCriticalPath(path)) return;

  recordApiMetric({
    method,
    path,
    status: response.status,
    durationMs: computeDuration(startedAt),
    ok: response.status >= 200 && response.status < 400,
    category: inferCategory(path),
  });
}

export function trackApiTelemetryFromAxiosError(error) {
  if (!error || !error.config) return;

  const { method, path, startedAt } = extractMeta(error.config);
  if (!isCriticalPath(path)) return;

  const status = Number(error?.response?.status) || 0;

  recordApiMetric({
    method,
    path,
    status,
    durationMs: computeDuration(startedAt),
    ok: false,
    category: inferCategory(path),
  });

  recordApiError({
    method,
    path,
    status,
    errorCode: error?.response?.data?.error || error?.code || "network_error",
    category: inferCategory(path),
  });
}
